import { getTranslation } from '~/tools/utils'

export const getStockAssignmentByItemIndex = (fulfillmentLineItem, itemIndex) => {
    if (!fulfillmentLineItem.stock_assignments?.length) return null

    let counter = itemIndex + 1
    // biome-ignore lint/style/useForOf: <explanation>
    for (let i = 0; i < fulfillmentLineItem.stock_assignments.length; i++) {
        const assignment = fulfillmentLineItem.stock_assignments[i]
        counter -= assignment.quantity
        if (counter <= 0) return assignment
    }
    return fulfillmentLineItem.stock_assignments[fulfillmentLineItem.stock_assignments.length - 1]
}

// Helper function moved out of component
export const extractSaleLineItemInfo = (saleLineItem, language) => ({
    image: saleLineItem.stock_unit?.product?.cover_image_url || saleLineItem.image,
    productName: saleLineItem.stock_unit?.product
        ? getTranslation(saleLineItem.stock_unit.product, language, 'name')
        : saleLineItem.product_name,
    sku: saleLineItem.stock_unit?.sku || saleLineItem.sku,
    skuName: saleLineItem.stock_unit?.sku_name || saleLineItem.stock_unit_name,
    barcode: saleLineItem.stock_unit?.barcode,
})

export const extractFulfillmentLineItemInfo = (fulfillmentLineItem, sale, language) => {
    const saleLineItem = sale.sale_line_items.find(
        (sli) => sli.id === fulfillmentLineItem.sale_line_item
    )

    const stockItem = fulfillmentLineItem.stock_record?.stock_item || {}

    return {
        image: saleLineItem.stock_unit?.product?.cover_image_url || saleLineItem.image,
        productName: saleLineItem.stock_unit?.product
            ? getTranslation(saleLineItem.stock_unit.product, language, 'name')
            : saleLineItem.product_name,
        sku: saleLineItem.stock_unit?.sku || saleLineItem.sku,
        skuName: saleLineItem.stock_unit?.sku_name || saleLineItem.stock_unit_name,
        barcode: stockItem.barcode,
        serialNumbers: fulfillmentLineItem.stock_assignments
            ?.map((sa) => sa?.physical_item?.serial_number || sa.assignSerialNumber)
            .filter(Boolean),
    }
}
